"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lngList = void 0;
// https://www.i18next.com/
const i18next_1 = __importDefault(require("i18next"));
const en_US_json_1 = __importDefault(require("./en-US.json"));
const ja_JP_json_1 = __importDefault(require("./ja-JP.json"));
const zh_CN_json_1 = __importDefault(require("./zh-CN.json"));
const china_icon_svg_1 = __importDefault(require("./icon/china_icon.svg"));
const japan_icon_svg_1 = __importDefault(require("./icon/japan_icon.svg"));
const uk_icon_svg_1 = __importDefault(require("./icon/uk_icon.svg"));
const DEBUG = process.env.NODE_ENV === 'development';
const LOCALES = [
    {
        tag: 'zh-CN',
        lng: '简体中文',
        res: zh_CN_json_1.default,
        icon: china_icon_svg_1.default,
    },
    {
        tag: 'ja-JP',
        lng: '日本語',
        res: ja_JP_json_1.default,
        icon: japan_icon_svg_1.default,
    },
    {
        tag: 'en-US',
        lng: 'English',
        res: en_US_json_1.default,
        icon: uk_icon_svg_1.default,
    },
];
exports.lngList = LOCALES;
// LOCALES -> {'zh-CN': {translation: {...}}}
const resources = LOCALES.reduce((acc, { tag, res }) => ({ ...acc, [tag]: { translation: res } }), {});
const standardizeLocale = (language) => {
    if (language in resources) {
        return language;
    }
    switch (language.substr(0, 2).toLowerCase()) {
        case 'zh':
            return 'zh-CN';
        case 'ja':
            return 'ja-JP';
        default:
            return 'en-US';
    }
};
const DEFAULT_LANG = navigator.language;
const language = standardizeLocale(DEFAULT_LANG);
i18next_1.default.init({
    lng: language,
    resources,
    debug: DEBUG,
    interpolation: {
        escapeValue: false,
    },
});
exports.default = i18next_1.default;
